var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('div',{staticClass:"class-name center-text nes-container is-rounded"},[_c('h3',[_vm._v(_vm._s(_vm.className))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }